"use client";

import styles from "./card.module.css";
import { FiInfo } from "react-icons/fi";
import { useUserDataContext } from "../user-data-context";
import { useTranslations } from "next-intl";

export default function ActivityCard({}) {
  const { state } = useUserDataContext();
  const t = useTranslations("MyAccount");

  return (
    <div className={styles.cardWrapper}>
      <div className={styles.detailsWrapper}>
        <div className={styles.infoRow}>
          <p className={styles.textRow}>
            <span className={styles.rowTitle}>{t("numberOfListings")}</span>
            <span className={styles.rowDetails}>
              {state.number_of_listings}
            </span>
          </p>
          <FiInfo
            className={styles.infoIcon}
            aria-label={t("ariaNumberOfListingsInfo")}
          />
        </div>
        <div className={styles.infoRow}>
          <p className={styles.textRow}>
            <span className={styles.rowTitle}>{t("sold")}</span>
            <span className={styles.rowDetails}>{state.properties_sold}</span>
          </p>
          <FiInfo className={styles.infoIcon} aria-label={t("ariaSoldInfo")} />
        </div>
        <div className={styles.infoRow}>
          <p className={styles.textRow}>
            <span className={styles.rowTitle}>{t("active")}</span>
            <span className={styles.rowDetails}>{state.active_listings}</span>
          </p>
          <FiInfo
            className={styles.infoIcon}
            aria-label={t("ariaActiveInfo")}
          />
        </div>
        <div className={styles.infoRow}>
          <p className={styles.textRow}>
            <span className={styles.rowTitle}>{t("inactive")}</span>
            <span className={styles.rowDetails}>{state.inactive_listings}</span>
          </p>
          <FiInfo
            className={styles.infoIcon}
            aria-label={t("ariaInactiveInfo")}
          />
        </div>
        <div className={styles.infoRow}>
          <p className={styles.textRow}>
            <span className={styles.rowTitle}>{t("moneySpent")}</span>
            <span className={styles.rowDetails}>{state.money_spent}$</span>
          </p>
          <FiInfo
            className={styles.infoIcon}
            aria-label={t("ariaMoneySpentInfo")}
          />
        </div>
        <div className={styles.infoRow}>
          <p className={styles.textRow}>
            <span className={styles.rowTitle}>{t("salesValue")}</span>
            <span className={styles.rowDetails}>{state.sales_value}$</span>
          </p>
          <FiInfo
            className={styles.infoIcon}
            aria-label={t("ariaSalesValueInfo")}
          />
        </div>
      </div>
    </div>
  );
}

export function ActivityCardLoading() {
  return (
    <div className={styles.cardWrapper}>
      <div className={styles.detailsWrapper}>
        <div className={styles.infoRow}>
          <p
            className={`${styles.textRow} ${styles.isLoading}`}
            style={{ width: "70%" }}
          ></p>
        </div>
        <div className={styles.infoRow}>
          <p
            className={`${styles.textRow} ${styles.isLoading}`}
            style={{ width: "55%" }}
          ></p>
        </div>
        <div className={styles.infoRow}>
          <p
            className={`${styles.textRow} ${styles.isLoading}`}
            style={{ width: "90%" }}
          ></p>
        </div>
        <div className={styles.infoRow}>
          <p
            className={`${styles.textRow} ${styles.isLoading}`}
            style={{ width: "84%" }}
          ></p>
        </div>
        <div className={styles.infoRow}>
          <p
            className={`${styles.textRow} ${styles.isLoading}`}
            style={{ width: "60%" }}
          ></p>
        </div>
        <div className={styles.infoRow}>
          <p
            className={`${styles.textRow} ${styles.isLoading}`}
            style={{ width: "75%" }}
          ></p>
        </div>
      </div>
    </div>
  );
}
